import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { AuthContext } from "../../lib/auth";
import HeaderLogo from '../../../src/images/logo2.png';
import { BsFillPersonFill } from "react-icons/bs";

const App = (props: any) => {
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [userAttributes, setUserAttributes] = useState<any>(null);
  const auth = useContext(AuthContext);

  useEffect(() => {
    if (currentUser?.attributes?.identities) {
      const attr = JSON.parse(currentUser?.attributes?.identities);
      setUserAttributes(attr[0]);
    }
  }, [currentUser]);

  useEffect(() => {
    setCurrentUser(auth.currentUser);
  }, [auth]);

  return (
    <header id="header">
      <GlobalNav
        userAttributes={userAttributes}
      />
    </header>
  );
};

const GlobalNav = (props: any) => {
  const auth = useContext(AuthContext);

  return (
    <>
      <script src="http://res2.wx.qq.com/open/js/jweixin-1.4.0.js" />
      <Navbar bg="dark" variant="dark" expand="lg">
        <Navbar.Brand as={Link} to="/" className="w-25">
          <img src={HeaderLogo} alt="Weマーケ!" className="mr-2" style={{"width": "100px"}} />
          {process.env.REACT_APP_STAGE === 'dev' && <>dev</>}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            {auth.currentUser &&
              <Nav.Link as={Link} to="/auth/mypage">
                マイページ
              </Nav.Link>
            }
            <Nav.Link as={Link} to="/rule">
              利用規約
            </Nav.Link>
            <Nav.Link as={Link} to="/privacy">
              プライバシーポリシー
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" className="mr-3">
              お問合せ
            </Nav.Link>
          </Nav>
          <SignInTitle auth={auth} userAttributes={props.userAttributes} />
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

const SignInTitle = (props: any) => {
  if (props.auth.currentUser) {
    return (
      <Navbar.Text className="">
        <BsFillPersonFill className="h4 mr-1" />{props.auth.currentUser?.attributes?.email} さん
        <span className="ml-2">
          <Link to="/auth/signout">ログアウト</Link>
        </span>
      </Navbar.Text>

    );
  }
  return (
    <></>
  );
};

export default App;
